export const emptySegmentState = {
    assets: {},
    content: {},
};
